import { z } from 'zod';
export const UploadBatchItem = z.object({
    albumId: z.string().min(1),
    clientFileId: z.string().min(1),
    sizeBytes: z.number().int().positive(),
    partsHint: z.number().int().positive(),
    encryptedMeta: z.string().min(1),
});
export const UploadBatchRequest = z.object({
    items: z.array(UploadBatchItem).min(1).max(100),
});
export const UploadBatchResultItem = z.object({
    clientFileId: z.string(),
    albumId: z.string(),
    photoId: z.string(),
    s3Key: z.string(),
    uploadId: z.string(),
    partUrls: z.array(z.string().url()),
    // Presigned URL for the final CompleteMultipartUpload S3 call. The client
    // POSTs the parts XML here directly, so a tab crash between part uploads
    // and the DDB flip cannot leave an orphan completed object: EventBridge
    // (Object Created) fires only after this call succeeds.
    completeUrl: z.string().url(),
});
export const UploadBatchResponse = z.object({
    items: z.array(UploadBatchResultItem),
});
export const UploadCompleteItem = z.object({
    albumId: z.string().min(1),
    photoId: z.string().min(1),
    uploadId: z.string().min(1),
    parts: z
        .array(z.object({
        partNumber: z.number().int().positive(),
        etag: z.string().min(1),
    }))
        .min(1),
});
export const UploadCompleteRequest = z.object({
    items: z.array(UploadCompleteItem).min(1).max(100),
});
// `albumId` is required alongside `photoId` because Photo records are keyed
// by (albumId, photoId) — without it the backend would have to scan to
// resolve the row. Callers already know the album from the listing endpoint.
export const DownloadBatchRequest = z.object({
    items: z
        .array(z.object({
        albumId: z.string().min(1),
        photoId: z.string().min(1),
    }))
        .min(1)
        .max(200),
});
export const DownloadBatchResponse = z.object({
    items: z.array(z.object({
        photoId: z.string(),
        url: z.string().url(),
        expiresAt: z.string(),
    })),
});
//# sourceMappingURL=upload.js.map